// extracted by mini-css-extract-plugin
export default {"wallet":"KeplrAccount_wallet__uoCGy"};